<div class="container">
    <div class="logOutText"> {{ 'endpoint_logOut_text' | lbTranslateFromKey:{lang:locale.language} }} </div>
    <button class="comeBackButton button primary" (click)="navigateService.goTo('/' + applicationId)" *ngIf="applicationId"> Revenir à l'application </button>
    <img class="linebertyLogo" alt="lineberty logo" src="assets/img/lineberty_logo.svg" />
</div>
